import { useState } from "react"
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox"
import { ChapterConfig } from "../../ChapterConfig"
import { ChapterSectionRoutes } from "../../ChapterSectionRoutes"
import { FlexRowTwo } from "../../../Layouts/FlexRows"
import { DotNav } from "../../../Comps/DotNav/DotNav"
import { HexPattern } from "../../../Comps/HexPattern/HexPattern"
import { ClassNames } from "../../../Util/ClassNames"
import './IntervalsChapter.scss'

export function IntervalsChapter(props:ChapterConfig){
    return  <div>
                    <ChapterSectionRoutes  path={props.path}
                                    lesson={<Lesson/>}
                                    exercises={<Exercises/>}
                                    resources={<Resources/>}/>
            </div>
}

export function Lesson(){
    return(
        <div className={'intervals-chapter'}><Intervals/></div>
    )
}
export function Exercises(){
    return  <div>Exercises</div>
}
export function Resources(){
    return <div>HexPattern Resources body</div>
}
export function Intervals(){
    const intervalNames:string[] = [
        'b2nd','2nd','b3rd','3rd','4th','b5th','5th','b6th','6th','b7th','7th','Octave'
    ]
    const sequence:number[] = [1,3,4,6,8,10,0,2,5,7,9,11]
    const [screenIndex, setScreenIndex] = useState(0)
    const getIntervalsRows = () => {
        const rows:JSX.Element[] = [<IntervalRow isSelected={false} label={'Name'} interval={'Interval'}/>]
        for(let i = 0; i < intervalNames.length; i++){
            const interval:number = i + 1
            const activeIndexes:number[] = sequence.slice(0, screenIndex)
            const isLast:boolean = activeIndexes[activeIndexes.length-1] === i
            const label = (activeIndexes.includes(i)) ? intervalNames[i] : ' '
            rows.push(<IntervalRow isSelected={isLast} label={label} interval={String(interval)}/>)
        }
        return rows
    }
    const getHilitedNotes = () => {
        const hilitedNotes:number[] = [0]
        if(screenIndex > 0 && screenIndex < 7){ hilitedNotes.push(screenIndex)}
        return hilitedNotes
    }
    const onNavClick = (n:number) => {
        setScreenIndex(n)
    }
    return(
        <div>
            <h1>Interval Names</h1>
            <OutlineBox width={850} title={'The Distance from the Tonic to Each Position'}>
                <FlexRowTwo columnOneFlex={1} columnTwoFlex={1}>
                    <HexPattern hilitedNotes={getHilitedNotes()} radius={120}/>
                    <div className={'interval-rows'}>
                        {getIntervalsRows()}
                    </div>
                </FlexRowTwo>

                <DotNav length={intervalNames.length + 1} selectedIndex={screenIndex} onClick={onNavClick}/>
            </OutlineBox>
        </div>
    )
}
export function IntervalRow(props:{label:string, interval:string, isSelected?:boolean}){
    const classNames:ClassNames = new ClassNames(['interval-row'])
    if(props.isSelected){
        classNames.addClass('selected')
    }
    return(
        <FlexRowTwo classNames={classNames.classNames} columnOneFlex={1} columnTwoFlex={1}>
            <div className={'label'}>{props.label}</div>
            <div className={'value'}>{props.interval}</div>
        </FlexRowTwo>
    )
}